/**
 * @generated SignedSource<<cfc8ebd893c9a0b6e980cbc04a2e97b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameMailingListInput = {
  id: string;
  name: string;
};
export type MailingListDetailsViewRenameMutation$variables = {
  input: RenameMailingListInput;
};
export type MailingListDetailsViewRenameMutation$data = {
  readonly renameMailingList: {
    readonly id: string;
    readonly name: string;
  };
};
export type MailingListDetailsViewRenameMutation = {
  response: MailingListDetailsViewRenameMutation$data;
  variables: MailingListDetailsViewRenameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "renameMailingList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MailingListDetailsViewRenameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MailingListDetailsViewRenameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6f7552f50ef37720b5a3d4d8b9aa6800",
    "id": null,
    "metadata": {},
    "name": "MailingListDetailsViewRenameMutation",
    "operationKind": "mutation",
    "text": "mutation MailingListDetailsViewRenameMutation(\n  $input: RenameMailingListInput!\n) {\n  renameMailingList(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "15b9a8e0b9f37c38d28554db43a70cdf";

export default node;
